<template>
  <div class="card border-0 bg-light mb-3">
    <div class="card-body p-3">
      <div v-if="showAssignButton" class="d-grid mb-2">
        <button
          type="button"
          class="btn btn-primary"
          :disabled="!canAssign || isLoading"
          @click="$emit('assign')"
        >
          <span
            v-if="isLoading"
            class="spinner-border spinner-border-sm me-2"
            role="status"
            aria-hidden="true"
          ></span>
          {{ isLoading ? "Assigning..." : assignLabel }}
        </button>
      </div>
      <p
        v-if="showAssignButton && !canAssign && assignDisabledReason"
        class="text-danger small mb-2"
      >
        {{ assignDisabledReason }}
      </p>

      <div v-if="showEditButton || showShareButton" class="d-grid gap-2">
        <button
          v-if="showEditButton"
          type="button"
          class="btn btn-outline-primary"
          @click="$emit('edit')"
        >
          Edit my report
        </button>
        <button
          v-if="showShareButton"
          type="button"
          class="btn btn-outline-secondary"
          @click="handleShare"
        >
          {{ shareButtonText }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AssignmentActions",
  props: {
    showAssignButton: {
      type: Boolean,
      default: false
    },
    canAssign: {
      type: Boolean,
      default: false
    },
    assignLabel: {
      type: String,
      default: "Assign myself to this island"
    },
    assignDisabledReason: {
      type: String,
      default: ""
    },
    showEditButton: {
      type: Boolean,
      default: false
    },
    showShareButton: {
      type: Boolean,
      default: false
    },
    isLoading: {
      type: Boolean,
      default: false
    }
  },
  emits: ["assign", "edit", "share"],
  data() {
    return {
      shareButtonText: "Share link"
    };
  },
  methods: {
    async handleShare() {
      try {
        const url = window.location.href;
        await navigator.clipboard.writeText(url);
        this.shareButtonText = "Copied!";
        this.$emit("share");
        // reset the share button text after 2 seconds
        setTimeout(() => {
          this.shareButtonText = "Share link";
        }, 2000);
      } catch (error) {
        console.error("Failed to copy link:", error);
        this.shareButtonText = "Copy failed";
        // reset the share button text after 2 seconds
        setTimeout(() => {
          this.shareButtonText = "Share link";
        }, 2000);
      }
    }
  }
};
</script>
